/// <reference types="vite/client" />

const config = {
  apiURL: import.meta.env.VITE_API_URL,
  shopify: {
    clientId: import.meta.env.VITE_SHOPIFY_CLIENT_ID,
    redirect: import.meta.env.VITE_SHOPIFY_REDIRECT,
    scope:
      'write_orders,write_draft_orders,write_fulfillments,write_inventory,write_products,write_assigned_fulfillment_orders,write_third_party_fulfillment_orders,write_returns,read_locations',
  },
  hellosign: {
    clientId: import.meta.env.VITE_HELLOSIGN_CLIENT_ID,
    skipDomainVerification: import.meta.env.VITE_HELLOSIGN_SKIP_DOMAIN_VERIFICATION === 'true',
  },
  env: import.meta.env.VITE_ENV,
  isDevelopment: import.meta.env.VITE_ENV === 'development',
  isStaging: import.meta.env.VITE_ENV === 'staging',
  isProduction: import.meta.env.VITE_ENV === 'production',
  isTest: import.meta.env.VITE_ENV === 'test',
  pathBasename: import.meta.env.VITE_BASENAME,
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  segment: {
    writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  },
};

export default config;
